import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../utils/client";
import { store } from "../../store";
import { UPDATE } from "../filter/filterSlice";

type CategoryState = {
  isCategoryLoading: boolean;
  error: string | null;
  parentCategories: any;
  childCategories: any;
  category: any;
};

const initialState: CategoryState = {
  isCategoryLoading: false,
  error: null,
  parentCategories: [],
  childCategories: [],
  category: null,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setLoading(state: any, action: { payload: any }) {
      state.isCategoryLoading = action.payload;
    },
    setParentCategories(state: any, action: { payload: any }) {
      state.parentCategories = action.payload;
    },
    setChildCategories(state: any, action: { payload: any }) {
      state.childCategories = action.payload;
    },
    setCategory(state: any, action: { payload: any }) {
      state.category = action.payload;
    },
  },
});

export default categorySlice.reducer;

const { actions } = categorySlice;
export const {
  setLoading,
  setParentCategories,
  setChildCategories,
  setCategory,
} = actions;

export function getParentCategories(category_id?: number) {
  return async (dispatch: any, getState: () => any) => {
    try {
      dispatch(actions.setLoading(true));
      dispatch(actions.setParentCategories([]));
      const response = await axiosInstance.get("/categories/parent/list");
      
      if (response?.status === 200) {
        // console.log(response.data.find((item:any) => item.id === category_id));
        const structuredData = {
          checkBoxFilters: [
            {
              title: "Category",
              filters: response.data.map((item: any) => ({
                title: item.name,
                selected: item.id === category_id,
                value: item.id,
              })),
            },
          ],
        };
        // console.log(structuredData);
        dispatch(UPDATE(structuredData));
        dispatch(actions.setParentCategories(response.data));
        dispatch(actions.setLoading(false));
      } else {
        dispatch(actions.setLoading(false));
      }
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
}
